import React from 'react';
import './StepApproval.scss';
import BaseComponent from '../../../baseClasses/BaseComponent';

export default class stepApproval extends BaseComponent {
  constructor(props) {
    super(props);
    this.clicked = false;
  }
  render() {
    const { userStepPermissions } = this.props;
    let buttonText = '';
    let className = '';
    if (userStepPermissions.has('is_approver')) {
      buttonText = 'Approve';
      className = 'approve';
    }
    else {
      buttonText = 'Review';
      className = 'review';
    }

    return (
      <div className="step-approval">
        <button onClick={e => { if (!this.clicked) { this.clicked = true; this.props.handleStepReject(e); } }} className="reject">Reject</button>
        <button onClick={e => { if (!this.clicked) { this.clicked = true; this.props.handleStepApprove(e); } }} className={className}>{buttonText}</button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TaskCompletionStepsMobile/StepApproval/index.js